import CrossIcon from '../assets/icons/24/cross.svg';

export default CrossIcon;
